import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { ConsultantCapabilityConfiguration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { ConsultantSpecializationService } from './api/consultantSpecialization.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class ConsultantCapabilityApiModule {
    public static forRoot(configurationFactory: () => ConsultantCapabilityConfiguration): ModuleWithProviders<ConsultantCapabilityApiModule> {
        return {
            ngModule: ConsultantCapabilityApiModule,
            providers: [ { provide: ConsultantCapabilityConfiguration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ConsultantCapabilityApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ConsultantCapabilityApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
